import { FieldValues, Path, UseFormSetError } from 'react-hook-form';

const TRANSFORMED_FIELDS = [
  'images',
  'commonImages',
  'entriesImages',
  'schedules',
  'linkParameters',
  'contentContainers',
];

type NestedErrors = Record<string, string[] | Record<string, string[] | Record<string, string[]>>>;

// eslint-disable-next-line @typescript-eslint/no-restricted-types -- error payloads are genuinely untyped
const transformErrors = (errors: unknown, _index: number | null): Record<string, string> => {
  if (!errors || typeof errors !== 'object') return {};
  const typedErrors = errors as NestedErrors;

  try {
    const err: Record<string, string> = {};

    Object.keys(typedErrors).forEach((field: string) => {
      const fieldName = field;
      const fieldErrors = typedErrors[field];

      if (Array.isArray(fieldErrors) && !TRANSFORMED_FIELDS.includes(field)) {
        err[fieldName] = fieldErrors[0] ?? '';
      } else if (fieldErrors && !Array.isArray(fieldErrors)) {
        Object.keys(fieldErrors).forEach((nested: string) => {
          const nestedFields = fieldErrors[nested];

          if (Array.isArray(nestedFields)) {
            err[`${fieldName}Attributes.${nested}`] = nestedFields[0] ?? '';
          } else if (nestedFields) {
            Object.keys(nestedFields).forEach((nestedFieldName: string) => {
              const deepErrors = nestedFields[nestedFieldName];
              if (Array.isArray(deepErrors)) {
                err[`${fieldName}Attributes.${nested}.${nestedFieldName}`] = deepErrors[0] ?? '';
              }
            });
          }
        });
      }
    });

    return err;
  } catch (error) {
    console.log(error);
  }

  return {};
};

// eslint-disable-next-line @typescript-eslint/no-restricted-types -- error payloads are genuinely untyped
export const setFormErrors = <T extends FieldValues>(setError: UseFormSetError<T>, errors: unknown): void => {
  const transformedErrors = transformErrors(errors, null);
  Object.keys(transformedErrors).forEach((field) => {
    setError(field as Path<T>, {
      type: 'custom',
      message: transformedErrors[field] ?? '',
    });
  });
};

export default transformErrors;
